import { IsNotEmpty, Min } from "class-validator"
import { v4 as uuid } from "uuid"

import { Serializable } from "@/core/api/decorators/serializable_decorator"

// Shared interface for price category data
export interface PriceCategoryBaseData {
  uid: string
  parentId: string
  name: string
  subtitle: string
  priceType: number
  numConsultants?: number
  hourlyRateOverwrite?: number
  maxHoursInContract?: number
  fixedPriceTotalValue?: number
}

@Serializable
export class PriceCategoryBaseModel {
  uid: string = uuid()
  parentId: string = ""
  @IsNotEmpty({
    message: "prices:errors.empty",
    groups: ["create_category", "edit_category"],
  })
  name: string = ""
  @IsNotEmpty({
    message: "prices:errors.empty",
    groups: ["create_category", "edit_category"],
  })
  subtitle: string = ""
  priceType: number = 0
  @Min(0, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  numConsultants: number = 0
  @Min(0, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  hourlyRateOverwrite: number = 0
  @Min(0, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  maxHoursInContract: number = 0
  @Min(0, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  fixedPriceTotalValue: number = 0

  constructor(data: PriceCategoryBaseData | null = null) {
    if (data) {
      this.uid = data.uid
      this.parentId = data.parentId
      this.name = data.name
      this.subtitle = data.subtitle
      this.priceType = data.priceType
      if (data.numConsultants !== undefined)
        this.numConsultants = data.numConsultants
      if (data.hourlyRateOverwrite !== undefined)
        this.hourlyRateOverwrite = data.hourlyRateOverwrite
      if (data.maxHoursInContract !== undefined)
        this.maxHoursInContract = data.maxHoursInContract
      if (data.fixedPriceTotalValue !== undefined)
        this.fixedPriceTotalValue = data.fixedPriceTotalValue
    }
  }
}
